import React from "react";
import { NavLink, Link } from "react-router-dom";

// icons
import IconSearch from "react-icons/lib/md/search";
import Tsc from "react-icons/lib/ti/clipboard";
import WalletIcon from "react-icons/lib/md/email";
import HelpIcon from 'react-icons/lib/md/help-outline'
import TicketSearch from "react-icons/lib/md/question-answer"
import FlightOperationIcon from "react-icons/lib/md/flight"
import PassengerIcon from "react-icons/lib/md/date-range"


const AirlineStaffMenuComponent = ({ handleClick, selected }) => {
  return (
    <ul className="list-unstyled mt-3 nav-list clearfix">
      
      <li
        onClick={handleClick.bind(this, 2)}
        className={selected === 2 ? "selected" : ""}
      >
        <NavLink exact to="/search" activeClassName="active">
          <IconSearch size="20" color="#43a8df" />
          <span className="name">
            Manifest
            <br /> Report
          </span>
        </NavLink>
      </li>
      <li
        onClick={handleClick.bind(this, 4)}
        className={selected === 4 ? "selected" : ""}
      >
        <NavLink to="/tsc" activeClassName="active">
          <Tsc size="18" color="#43a8df" className="icon-clipboard" />
          <span className="name">TSC Statement</span>
        </NavLink>
      </li>
      <li
        onClick={handleClick.bind(this, 5)}
        className={selected === 5 ? "selected" : ""}
      >
        <NavLink to="/dispute-log" activeClassName="active">
          <WalletIcon size="18" className="FaEdit" />
          <span className="name">Dispute Log</span>
        </NavLink>
      </li>
      <li>
        <NavLink to="/airline-wallet-history" activeClassName="active">
          <WalletIcon size="18" className="FaEdit" />
          <span className="name">Wallet History</span>
        </NavLink>
      </li>
      <li>
        <NavLink to="/ticket-search" activeClassName="active">
          <TicketSearch size="18" />
          <span className="name">
            Search By
            <br /> Ticket
          </span>
        </NavLink>
      </li>
      <li>
        <NavLink to="/flight-operations" activeClassName="active">
          <FlightOperationIcon size="18" className="icon-insert-chart" />
          <span className="name">
            Flight <br /> Operations
          </span>
        </NavLink>
      </li>
      <li
      >
        <NavLink to="/passenger-level-data" activeClassName="active">
          <PassengerIcon size="18" className="icon-insert-chart" />
          <span className="name">
           Passenger level <br /> Data
          </span>
        </NavLink>
      </li>
      <hr></hr>

      <li
        onClick={handleClick.bind(this, 68)}
        className={selected === 68 ? "selected" : ""}
      >
        <NavLink to="/help-center" activeClassName="active">
          <HelpIcon size="18" className="icon-insert-chart" />
          <span className="name">Help Center</span>
        </NavLink>
      </li>
    </ul>
  );
};

export default AirlineStaffMenuComponent;



// WEBPACK FOOTER //
// ./src/shared/components/nav/menu/airline_staff.js